// extracted by extract-css-chunks-webpack-plugin
module.exports = {"summary":"summary___2dgOs"};